/**
 * React Router action handler for workpack creation from the map page.
 *
 * Processes POST requests containing workpack form data with geometry,
 * converts the geometry to an OpenLayers feature (AOI), and returns
 * the workpack data and AOI for use in the route component.
 *
 * @param {Object} request - React Router request object containing form data
 * @returns {Object} Object containing workpack data and AOI feature, or empty object if invalid
 */

import { formDataToJson } from 'client/utils/helpers/Workpack/Workpack';
import GeoJSON from 'ol/format/GeoJSON';
import { MAP_PAGE } from 'client/utils/routes/routeConstants';
import { redirect } from 'react-router';

const action = async ({ request }) => {
    if (request.method !== 'POST') {
        redirect(MAP_PAGE);
        return {};
    }
    const formData = await request?.formData();
    const workpack = formDataToJson(formData);
    const geometry = workpack?.geometry;
    // kick user out if no geometry
    if (!geometry) {
        redirect(MAP_PAGE);
        return {};
    }

    const aoi = new GeoJSON().readFeature({ geometry: { ...geometry }, type: 'Feature' });

    return { workpack, aoi };
};

export default action;
